const _excluded = ["ref"],
      _excluded2 = ["ref", "onChange"],
      _excluded3 = ["ref", "onChange", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { titleValidation } from 'validators';

/** easily connects an input ref and its error validation */
export const connectControllerToTextField = (props, options) => {
  const _props$field = props.field,
        {
    ref
  } = _props$field,
        rest = _objectWithoutProperties(_props$field, _excluded);

  const {
    showErrors,
    errorMsg
  } = genericConnector(props, options);
  return _objectSpread({
    inputRef: ref,
    error: showErrors,
    helperText: errorMsg
  }, rest);
};
export const connectControllerToKeyboardDatePicker = (props, options) => {
  const {
    value,
    onChange
  } = props.field;
  const {
    showErrors,
    errorMsg
  } = genericConnector(props, options);
  return {
    value,
    onChange,
    error: showErrors,
    helperText: errorMsg
  };
};
export const connectControllerToAutocomplete = (props, options) => {
  const {
    value,
    name,
    ref,
    onBlur,
    onChange
  } = props.field;
  const {
    showErrors,
    errorMsg
  } = genericConnector(props, options);
  return {
    inputValue: value,
    textFieldProps: {
      name,
      error: showErrors,
      helperText: errorMsg,
      inputRef: ref
    },
    onBlur,
    onInputChange: onChange
  };
};
export const connectControllerToDiscountTextField = (props, options) => {
  const _props$field2 = props.field,
        {
    ref,
    onChange: _onChange
  } = _props$field2,
        rest = _objectWithoutProperties(_props$field2, _excluded2);

  const {
    showErrors,
    errorMsg
  } = genericConnector(props, options);
  return _objectSpread({
    inputRef: ref,
    error: showErrors,
    helperText: errorMsg,
    onChange: value => _onChange({
      target: {
        value
      }
    })
  }, rest);
};
/** easily connects a RichTextEditor to a Controller */

export const connectControllerToRichTextEditor = (props, options) => {
  const _props$field3 = props.field,
        {
    ref,
    onChange: _onChange2,
    value
  } = _props$field3,
        rest = _objectWithoutProperties(_props$field3, _excluded3);

  const {
    showErrors,
    errorMsg
  } = genericConnector(props, options);
  return _objectSpread({
    initialValue: value,
    editorRef: ref,
    onChange: v => _onChange2({
      target: {
        value: JSON.stringify(v)
      }
    }),
    error: showErrors,
    helperText: errorMsg
  }, rest);
};
export function genericConnector(_ref) {
  var _fieldState$error;

  let {
    fieldState,
    formState
  } = _ref;
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    noHelperText,
    alwaysShowErrors
  } = options;
  const showErrors = alwaysShowErrors ? !!fieldState.error : getShouldShowFieldError(fieldState, formState);
  const errorMsg = noHelperText ? undefined : showErrors ? (_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message : undefined;
  return {
    showErrors,
    errorMsg
  };
}

function getShouldShowFieldError(fieldState, formState) {
  return fieldState.error && (fieldState.isTouched || formState.isSubmitted);
}

export const agreementNameValidation = titleValidation('Agreement name', {
  required: 'Please provide an agreement name.'
});